var _style, _filter, _filter2, _filter3, _filter4, _filter5, _filter6, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{filter:url(#Path_122210);}\n\t.st2{fill:#5142FC;}\n\t.st3{filter:url(#Path_122211);}\n\t.st4{filter:url(#Path_122212);}\n\t.st5{fill:#DCF8C5;}\n\t.st6{filter:url(#Path_122212-2);}\n\t.st7{filter:url(#Path_122213);}\n\t.st8{filter:url(#Path_122214);}\n")), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    height: 5.911,
    id: "Path_122214",
    width: 8.945,
    x: 5.462,
    y: 0
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur-6",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "color-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    height: 5.912,
    id: "Path_122213",
    width: 11.82,
    x: 12.959,
    y: 0.001
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur-5",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "color-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    height: 18.583,
    id: "Path_122212-2",
    width: 18.583,
    x: 13.723,
    y: 10.945
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.502,
    result: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur-4",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "color-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    height: 18.583,
    id: "Path_122212",
    width: 18.583,
    x: 13.723,
    y: 10.945
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    operator: "over"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    height: 20.553,
    id: "Path_122211",
    width: 29.824,
    x: 0,
    y: 6.985
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur-2",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "color-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in"
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    height: 5.722,
    id: "Path_122210",
    width: 10.072,
    x: 19.752,
    y: 14.371
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5142fc",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "color",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_122210-2",
    className: "st0",
    d: "M15.89,14.79c0,1.27,1.03,2.3,2.3,2.3H24v-4.6h-5.8C16.93,12.49,15.9,13.52,15.89,14.79z  M19.58,14.79c0,0.61-0.49,1.1-1.09,1.1c-0.61,0-1.1-0.49-1.1-1.09c0-0.61,0.49-1.1,1.09-1.1c0,0,0,0,0,0 C19.09,13.69,19.58,14.18,19.58,14.79z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122210-3_00000091724074639649067670000014152297528702835120_",
    className: "st0",
    d: "M15.89,14.79 c0,1.27,1.03,2.3,2.3,2.3H24v-4.6h-5.8C16.93,12.49,15.9,13.51,15.89,14.79z M19.58,14.79c0,0.61-0.49,1.1-1.09,1.1 c-0.61,0-1.1-0.49-1.1-1.09c0-0.61,0.49-1.1,1.09-1.1c0,0,0,0,0,0C19.09,13.69,19.58,14.18,19.58,14.79z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_122211-2",
    className: "st2",
    d: "M23.01,6.54H0.99C0.44,6.54,0,6.98,0,7.53v14.56c0,0.55,0.44,0.99,0.99,0.99h22.02 c0.55,0,0.99-0.45,0.99-0.99v-4.14h-5.77c-1.73,0-3.14-1.4-3.14-3.14c0-1.73,1.4-3.14,3.14-3.14c0,0,0,0,0,0H24V7.53 C24,6.98,23.56,6.54,23.01,6.54z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122211-3_00000016058126969265778160000011521730851285364670_",
    className: "st0",
    d: "M23.01,6.54H0.99 C0.44,6.54,0,6.98,0,7.53v14.56c0,0.55,0.44,0.99,0.99,0.99h22.02c0.55,0,0.99-0.45,0.99-0.99v-4.14h-5.77 c-1.73,0-3.14-1.4-3.14-3.14c0-1.73,1.4-3.14,3.14-3.14c0,0,0,0,0,0H24V7.53C24,6.98,23.56,6.54,23.01,6.54z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122212-3_00000106136995057395351190000010093302381556516238_",
    className: "st5",
    d: "M18.52,15.02 c0.13,0,0.23-0.11,0.23-0.23s-0.11-0.23-0.23-0.23c-0.13,0-0.23,0.11-0.23,0.23l0,0C18.28,14.92,18.39,15.02,18.52,15.02z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122212-4_00000173877805299933362630000004092910578720426899_",
    className: "st0",
    d: "M18.52,15.02 c0.13,0,0.23-0.11,0.23-0.23s-0.11-0.23-0.23-0.23c-0.13,0-0.23,0.11-0.23,0.23l0,0C18.28,14.92,18.39,15.02,18.52,15.02z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_122213-2",
    className: "st2",
    d: "M19.94,5.68l-4.76-4.76l-2.74,2.74c0,0,0,0.01-0.01,0.01l-1.97,1.97l-0.04,0.04 L19.94,5.68z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122213-3_00000039101783628641606260000017295734012529028497_",
    className: "st0",
    d: "M19.94,5.68l-4.76-4.76l-2.74,2.74 c0,0,0,0.01-0.01,0.01l-1.97,1.97l-0.04,0.04L19.94,5.68z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_122214-2",
    className: "st2",
    d: "M4.4,5.68h4.88l2.31-2.32L9.15,0.92L4.4,5.68z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122214-3_00000020377646238060214800000000043321890763442836_",
    className: "st0",
    d: "M4.4,5.68h4.88l2.31-2.32 L9.15,0.92L4.4,5.68z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.9009cc40779dd1c9e9a173f2618ab941.svg";
export { ForwardRef as ReactComponent };